// Central content for ONE VISION landing page
export const BRAND = {
  name: "ONE VISION",
  tagline: "Safe Assets, Safe Nature",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_3b529be8-50b3-401e-82bb-ee64d6041929/artifacts/xodzrkfk_IMG_20260422_222327.png",
  website: "onevisionindia.net",
  websiteUrl: "https://onevisionindia.net",
  whatsapp: "8500442111",
  whatsappUrl: "https://wa.me/918500442111",
  instagram: "onevision_portal",
  instagramUrl: "https://instagram.com/onevision_portal",
  facebook: "ONEVISION",
  youtube: "ONEVISION",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBsdXh1cnklMjBidWlsZGluZ3xlbnwwfHx8fDE3ODUzNTY0MTB8MA&ixlib=rb-4.1.0&q=85",
  surveyor: "https://customer-assets-rejwkqb3.emergentagent.net/job_corporate-portal-hub-2/artifacts/qwbep09m_IMG-20260729-WA0002.jpg",
  architect: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=900&q=85&fm=jpg&auto=format",
  engineer: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=900&q=85&fm=jpg&auto=format",
  lawyer: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=900&q=85&fm=jpg&auto=format",
  founder: "https://customer-assets-rejwkqb3.emergentagent.net/job_corporate-portal-hub-2/artifacts/8j4zcih9_file_000000003ba081fa99db32a2b6616c7a.jpg",
};

export const TRUST = [
  { title: "Protect", sub: "What Matters", desc: "Rigorous verification shields your capital from hidden legal and structural risk." },
  { title: "Secure", sub: "Tomorrow", desc: "Every title, boundary and permission validated so ownership is never in doubt." },
  { title: "Build", sub: "A Better Future", desc: "Compliant, future-ready assets that appreciate with confidence and clarity." },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Verify before you buy",
    body: "We don't just review documents — we investigate them. Land records, encumbrances and revenue history are cross-checked at source, so a single overlooked line never becomes a lifelong dispute.",
  },
  {
    no: "02",
    title: "One panel, every discipline",
    body: "Surveyors, architects, engineers and lawyers work as one team on your file. No fragmented advice, no blind spots — a single, unified opinion you can act on.",
  },
  {
    no: "03",
    title: "Clarity over complexity",
    body: "Property law is dense; our reports are not. You receive plain-language findings, a clear risk rating and a defensible recommendation — verify today, buy tomorrow.",
  },
];

export const SERVICES = [
  { no: "01", title: "Survey & Land Records", price: 2999, desc: "Accurate land survey and records verification against ground reality." },
  { no: "02", title: "Revenue Records Verification", price: 1999, desc: "Pahani / Adangal / 1B / ROR verification from source." },
  { no: "03", title: "Registration & EC Verification", price: 2499, desc: "Registration records search and encumbrance certificate verification." },
  { no: "04", title: "Layout Approvals & Permissions", price: 4999, desc: "Government permissions and approved-layout validation." },
  { no: "05", title: "Title Search & Legal Opinion", price: 3499, desc: "Chain of title investigation with a defensible legal opinion." },
  { no: "06", title: "Property Tax Assessment", price: 1499, desc: "Assessment status, dues and compliance verification." },
  { no: "07", title: "Building Vaastu & Planning", price: 3999, desc: "Vaastu-aligned building planning and design guidance." },
  { no: "08", title: "Construction Guidance", price: 5999, desc: "On-site construction supervision and technical compliance." },
  { no: "09", title: "Banking & Legal Support", price: 4499, desc: "Loans, mortgage, disputes and SARFAESI advisory." },
];

export const EXPERTS = [
  { role: "Surveyors", desc: "Accurate land survey & records verification.", img: IMAGES.surveyor },
  { role: "Architects", desc: "Layout, building plans & approvals expertise.", img: IMAGES.architect },
  { role: "Engineers", desc: "Structural safety, construction & technical compliance.", img: IMAGES.engineer },
  { role: "Lawyers", desc: "Title search, legal opinion & risk assessment.", img: IMAGES.lawyer },
];

export const WHY = [
  "Expert panel of professionals",
  "100% verified & reliable reports",
  "Transparent, source-backed process",
  "Save money, time & future disputes",
  "Legally compliant & future ready",
];

export const TESTIMONIALS = [
  {
    quote: "One Vision caught an encumbrance the seller never disclosed. Their title report saved me from a decade of litigation.",
    name: "Ravi Teja",
    role: "Homebuyer, Hyderabad",
  },
  {
    quote: "The clarity of their legal opinion made our bank loan approval effortless. Every document was already validated.",
    name: "Sunita Reddy",
    role: "NRI Investor",
  },
  {
    quote: "Surveyors, engineers and lawyers under one roof — I got one clear answer instead of five conflicting ones.",
    name: "Mahesh Kumar",
    role: "Land Developer",
  },
];

export const SERVICE_OPTIONS = [
  "Survey & Land Records",
  "Revenue Records Verification",
  "Registration & EC Verification",
  "Layout Approvals & Permissions",
  "Title Search & Legal Opinion",
  "Property Tax Assessment",
  "Building Vaastu & Planning",
  "Construction Guidance",
  "Banking & Legal Support",
  "General Enquiry",
];
